import { AgreementTypeEnum } from './Enums'
import { ReservationRequest } from './ReservationRequest'

export interface AvailabilityRequest {
  oemName?: string
  dealerNumber?: string
  pickupDateTime?: Date
  dropOffDateTime?: Date
  reservationType?: AgreementTypeEnum
  modelGroup?: string
  includeRates?: boolean
  includeTotalPrice?: boolean
  isForecast?: boolean
  additionalFees?: string[]
  isReservation?: boolean
}

export function toAvailabilityRequestForPricing(resRequestInfo: ReservationRequest): AvailabilityRequest {
  const availabilityReq: AvailabilityRequest = {
    oemName: resRequestInfo.oemName,
    dealerNumber: resRequestInfo.dealerNumber,
    pickupDateTime: resRequestInfo.pickupDateTime,
    dropOffDateTime: resRequestInfo.dropOffDateTime,
    reservationType: resRequestInfo.reservationType,
    modelGroup: resRequestInfo.modelGroup,
    includeRates: resRequestInfo.includeRates,
    includeTotalPrice: true,
    isForecast: true,
    additionalFees: resRequestInfo.fees,
    isReservation: true
  }

  return availabilityReq
}
